import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ProjectIdInputDialogComponent } from './project-id-input-dialog/project-id-input-dialog.component';
import { Router } from '@angular/router';
import { ProjectConfiguration } from '@models/ProjectConfiguration';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class CommonTasksService {

  constructor(
    private router: Router,
    public dialog: MatDialog,
    private snackBar: MatSnackBar
  ) { }

  showSnackbarMessage(message: string, action: string = '', duration: number = 3000) {
    this.snackBar.open(message, action, {
      duration: duration,
    });
  }

  newProject(): void {
    const dialogRef = this.dialog.open(ProjectIdInputDialogComponent, {
      width: '400px',
      data: { text: '' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.router.navigate(['/settings/' + result]);
      }
    });
  }

  downloadProjectConfiguration(project: ProjectConfiguration) {
    const content = JSON.stringify(project.toObject(), null, 2);
    const fileName = `${project.id}.json`;
    const contentType = 'text/plain';
    this.downloadFile(content, fileName, contentType);
  }

  private downloadFile(content: string, fileName: string, contentType: string) {
    const blob = new Blob([content], { type: contentType });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }



}
